export const authResponseUrlKey = "auth.callback.url";

export function isAuthResponseUrl(): boolean {
  // Auth0 callback URL has a "code" param
  return /code=/g.test(window?.location?.href ?? "");
}
